import React, { useReducer } from "react";
import reducer from "../Reducer/Reducer";

export const ContextForClient = React.createContext([{}, () => {}]);

const ClientContextProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, {
    channels: [],
    loginUser: [],
    specifiedChannel: [],
    channelMember: [],
    posts: [],
    channelName: "random",
    resizeFlag: true,
    showTimesIcon: false,
    DropDownModal: false,
    joinChannelModal: false,
    allChannelsToJoin: [],
    nameDisplayHeader: "random",
    loadedMember: false,
    modalFlag: false,
  });

  return (
    <ContextForClient.Provider value={[state, dispatch]}>
      {props.children}
    </ContextForClient.Provider>
  );
};

export default ClientContextProvider;
